// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reason-container,.description-container,.file-upload-container{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    font-family:"PlusJakartaSans";
    color:rgb(69, 79, 91);
}
.reason-container label,.description-container label{
    margin-bottom:0.5rem;
}
.reason-container{
    margin-bottom:1.25rem;
}
.description-container{
    margin-bottom: 1rem;
}
.description-text,.reason-select{
    display: flex;
    align-items: center;
    width:100%;
    justify-content: space-between;
    font-family:"PlusJakartaSans";
    padding:0.75rem;
    border:1px solid rgb(223, 227, 232);
    border-radius:0.25rem;
    resize:none;
}
.call-request-checkbox{
    height:1rem;
    width: 1rem;
    border:1px solid rgb(235, 238, 241);
    text-decoration: none;
    outline:none;
}
.reason-select option{
    font-family:"PlusJakartaSans";
    color:rgb(69, 79, 91);
    padding:0.25rem;
}
/* .react-dropdown-select-dropdown-handle svg{
    width:24px !important;
} */
.call-request-container{
    display: flex;
    justify-content:flex-start;
    align-items: center;
    margin-bottom:1.25rem;
    color:rgb(69, 79, 91);
}
.call-request-container input,.call-request-container label{
    margin:0%;
    margin-right:0.25rem;
}
.ticket-upload-btn{
    border: 2px dotted rgb(64, 64, 242);
    background-color: transparent;
    padding:1rem;
    border-radius: 0.25rem;
    color:rgb(64, 64, 242);
    font-family:"PlusJakartaSans";
}
.file-upload-container label{
    margin-bottom:1rem; 
}`, "",{"version":3,"sources":["webpack://./src/pages/support/RiaseTicket/RaiseTicket.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,6BAA6B;IAC7B,qBAAqB;AACzB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,8BAA8B;IAC9B,6BAA6B;IAC7B,eAAe;IACf,mCAAmC;IACnC,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,mCAAmC;IACnC,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,eAAe;AACnB;AACA;;GAEG;AACH;IACI,aAAa;IACb,0BAA0B;IAC1B,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;AACzB;AACA;IACI,SAAS;IACT,oBAAoB;AACxB;AACA;IACI,mCAAmC;IACnC,6BAA6B;IAC7B,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".reason-container,.description-container,.file-upload-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    font-family:\"PlusJakartaSans\";\r\n    color:rgb(69, 79, 91);\r\n}\r\n.reason-container label,.description-container label{\r\n    margin-bottom:0.5rem;\r\n}\r\n.reason-container{\r\n    margin-bottom:1.25rem;\r\n}\r\n.description-container{\r\n    margin-bottom: 1rem;\r\n}\r\n.description-text,.reason-select{\r\n    display: flex;\r\n    align-items: center;\r\n    width:100%;\r\n    justify-content: space-between;\r\n    font-family:\"PlusJakartaSans\";\r\n    padding:0.75rem;\r\n    border:1px solid rgb(223, 227, 232);\r\n    border-radius:0.25rem;\r\n    resize:none;\r\n}\r\n.call-request-checkbox{\r\n    height:1rem;\r\n    width: 1rem;\r\n    border:1px solid rgb(235, 238, 241);\r\n    text-decoration: none;\r\n    outline:none;\r\n}\r\n.reason-select option{\r\n    font-family:\"PlusJakartaSans\";\r\n    color:rgb(69, 79, 91);\r\n    padding:0.25rem;\r\n}\r\n/* .react-dropdown-select-dropdown-handle svg{\r\n    width:24px !important;\r\n} */\r\n.call-request-container{\r\n    display: flex;\r\n    justify-content:flex-start;\r\n    align-items: center;\r\n    margin-bottom:1.25rem;\r\n    color:rgb(69, 79, 91);\r\n}\r\n.call-request-container input,.call-request-container label{\r\n    margin:0%;\r\n    margin-right:0.25rem;\r\n}\r\n.ticket-upload-btn{\r\n    border: 2px dotted rgb(64, 64, 242);\r\n    background-color: transparent;\r\n    padding:1rem;\r\n    border-radius: 0.25rem;\r\n    color:rgb(64, 64, 242);\r\n    font-family:\"PlusJakartaSans\";\r\n}\r\n.file-upload-container label{\r\n    margin-bottom:1rem; \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
